import "./style/PopupForm.css";
import { GrClose } from "react-icons/gr";
import { useEffect, useState } from "react";
import {
  addCoach,
  getCoach,
  signupCoach,
  updateCoach,
  updateCoachEmail,
} from "../../apicalls/coaches";
import { isAuthenticated } from "../../apicalls/auth";
import {API} from "../../../constAPI";
function PopupForm({ action, setPopup, coach_id }) {
  const [values, setValues] = useState({
    full_name: "",
    profile_picture: "",
    cid: "",
    about_me: "",
    hourly_rate: 0,
    price_private: "",
    price_semi: "",
    price_group: "",
    experience_years: "",
    certifications: "",
    other_languages: "",
    phone: 0,
    password: "",
    email: "",
    original_email: "",
    can_create_restring_orders: false,
    error: false,
    success: false,
    loading: false,
  });

  const user = isAuthenticated();
  const accessToken = user?.access_token;

  const {
    cid,
    full_name,
    about_me,
    hourly_rate,
    price_private,
    price_semi,
    price_group,
    experience_years,
    certifications,
    other_languages,
    password,
    email,
    original_email,
    can_create_restring_orders,
    phone,
    error,
    success,
  } = values;
  useEffect(() => {
    if (action !== "Edit" || !accessToken) {
      return;
    }

    getCoach(coach_id, accessToken).then((data) => {
      setValues((prev) => ({
        ...prev,
        cid: data[0]?.user_id,
        full_name: data[0]?.full_name,
        about_me: data[0]?.about_me,
        hourly_rate: data[0]?.hourly_rate,
        price_private: data[0]?.price_private ?? data[0]?.hourly_rate ?? "",
        price_semi: data[0]?.price_semi ?? "",
        price_group: data[0]?.price_group ?? "",
        experience_years: data[0]?.experience_years ?? "",
        certifications: data[0]?.certifications ?? "",
        other_languages: data[0]?.other_languages ?? "",
        profile_picture: data[0]?.profile_picture,
        phone: data[0]?.phone || "",
        email: data[0]?.email || "",
        original_email: data[0]?.email || "",
        can_create_restring_orders: Boolean(data[0]?.can_create_restring_orders),
      }));
    });
  }, [action, coach_id, accessToken]);

  const handleChange = (name) => (event) => {
    setValues({
      ...values,
      error: false,
      success: false,
      [name]: event.target.value,
    });
  };

  const handlePrivateRateChange = (event) => {
    setValues({
      ...values,
      error: false,
      success: false,
      hourly_rate: event.target.value,
      price_private: event.target.value,
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setValues({ ...values, error: false, success: false, loading: false });
    if (action === "Add") {
      if (!full_name || !email || !password) {
        setValues({
          ...values,
          error: "please fill required fields",
          success: false,
        });
        return;
      }
      signupCoach({ email, password, user_type: 1 }).then((data1) => {
        if (data1?.err?.code === "23505") {
          return setValues({
            ...values,
            error: "Email already Exist",
            success: false,
            loading: false,
          });
        }
        addCoach(
          {
            full_name,
            about_me,
            hourly_rate,
            price_private: price_private || hourly_rate,
            phone,
            user_id: data1.user_id,
          },
          user.access_token
        ).then((data) => {
          console.log(data);
          if (data[0]?.id) {
            setValues({
              ...values,
              full_name: "",
              about_me: "",
              hourly_rate: "",
              price_private: "",
              price_semi: "",
              price_group: "",
              experience_years: "",
              certifications: "",
              other_languages: "",
              phone: "",
              email: "",
              password: "",
              error: false,
              success: true,
              loading: false,
            });
          } else {
            setValues({
              ...values,
              error: "Please enter required fields",
              success: false,
              loading: false,
            });
          }
        });
      });
    }
    if (action === "Edit") {
      if (!full_name) {
        setValues({ ...values, error: "please fill fields", success: false });
        return;
      }
      updateCoach(cid || coach_id, user.access_token, {
        full_name,
        about_me,
        hourly_rate,
        price_private: price_private || hourly_rate,
        price_semi,
        price_group,
        experience_years,
        certifications,
        other_languages,
        phone,
        can_create_restring_orders,
      }).then((data) => {
        if (!Array.isArray(data) || !data[0]?.id) {
          setValues({
            ...values,
            error: data?.detail || data?.details || "Failed to update coach",
            success: false,
            loading: false,
          });
          return;
        }

        if (data[0].id) {
          const emailChanged = email && email !== original_email;
          const emailUpdate = emailChanged
            ? updateCoachEmail(cid || coach_id, email, user.access_token)
            : Promise.resolve(data);

          emailUpdate.then((emailData) => {
            if (emailData?.detail || emailData?.details) {
              setValues({
                ...values,
                error: emailData.detail || emailData.details,
                success: false,
                loading: false,
              });
              return;
            }

          setValues({
            ...values,
            full_name: "",
            about_me: "",
            hourly_rate: "",
            price_private: "",
            price_semi: "",
            price_group: "",
            experience_years: "",
            certifications: "",
            other_languages: "",
            phone: "",
            email: "",
            original_email: "",
            can_create_restring_orders: false,
            error: false,
            success: true,
          });
          });
        } else {
          setValues({ ...values, error: true, success: false, loading: false });
        }
      });
    }
  };

  const handleImageUpload = async (imageFile) => {
    try {
      const fileType = imageFile.type.split("/")[1];
      if (!["jpeg", "png"].includes(fileType)) {
        setValues({ ...values, error: "Unsupported file type" });
        return;
      }
  
      // Get presigned URL
      const res = await fetch(`${API}/api/admin/avatars?file_type=${fileType}&id=${values.cid}&for=coach`, {
        headers: { Authorization: `token ${user.access_token}` },
      });
      const { uploadURL, Key } = await res.json();
  
      // Upload image to S3
      await fetch(uploadURL, {
        method: "PUT",
        headers: { "Content-Type": imageFile.type },
        body: imageFile,
      });
  
      // Update state with the image key for backend
      setValues({ ...values, profile_picture: Key });
    } catch (error) {
      console.error(error);
      setValues({ ...values, error: "Image upload failed" });
    }
  };
  
  const handleImageSelect = (event) => {
    const imageFile = event.target.files[0];
    handleImageUpload(imageFile);
  };
  

  return (
    <div className="popup">
      <div className="popup-inner">
        <div
          className="close-btn"
          onClick={() => {
            setPopup("");
          }}
        >
          <GrClose />
        </div>
        <h1>{action} Coach</h1>.
        <div className="container">
          <div className="row">
            {error ? <span className="error">{error}</span> : ""}
            {success ? (
              <span className="success">
                Coach {action === "Add" ? "Added" : "Edited"} Successfully
              </span>
            ) : (
              ""
            )}
            <div className="form-content col-lg-6">
              <label htmlFor="">Full Name*</label>
              <br />
              <input
                type="text"
                value={full_name}
                onChange={handleChange("full_name")}
                placeholder="Enter Full Name"
                required
              />
            </div>
            {action === "Add" || action === "Edit" ? (
              <div className="form-content col-lg-6">
                <label htmlFor="">Email Address*</label>
                <br />
                <input
                  type="email"
                  value={email}
                  onChange={handleChange("email")}
                  placeholder="Enter Email Address"
                  required
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-content col-lg-6">
  <label htmlFor="">Profile Picture</label>
  <br />
  {values.profile_picture && (
    <img
      src={values.profile_picture}
      alt="Profile"
      style={{
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        marginBottom: "10px",
      }}
    />
  )}
  <input type="file" accept="image/*" onChange={handleImageSelect} />
</div>
            <div className="form-content col-lg-6">
              <label htmlFor="">About Me</label>
              <br />
              <input
                type="text"
                value={about_me}
                onChange={handleChange("about_me")}
                placeholder="Enter about coach"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-private-rate">Private Rate</label>
              <br />
              <input
                id="coach-private-rate"
                type="number"
                value={price_private}
                onChange={handlePrivateRateChange}
                placeholder="Enter Private Rate"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-semi-private-rate">Semi-private Rate</label>
              <br />
              <input
                id="coach-semi-private-rate"
                type="number"
                value={price_semi}
                onChange={handleChange("price_semi")}
                placeholder="Enter Semi-private Rate"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-group-rate">Group Rate</label>
              <br />
              <input
                id="coach-group-rate"
                type="number"
                value={price_group}
                onChange={handleChange("price_group")}
                placeholder="Enter Group Rate"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-experience-years">Experience Years</label>
              <br />
              <input
                id="coach-experience-years"
                type="number"
                value={experience_years}
                onChange={handleChange("experience_years")}
                placeholder="Enter Experience Years"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-certifications">Certifications</label>
              <br />
              <input
                id="coach-certifications"
                type="text"
                value={certifications}
                onChange={handleChange("certifications")}
                placeholder="Enter Certifications"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="coach-other-languages">Other Languages</label>
              <br />
              <input
                id="coach-other-languages"
                type="text"
                value={other_languages}
                onChange={handleChange("other_languages")}
                placeholder="Enter Other Languages"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="">Phone Number</label>
              <br />
              <input
                type="text"
                value={phone}
                onChange={handleChange("phone")}
                placeholder="Enter coach no."
              />
            </div>
            {action === "Edit" ? (
              <div className="form-content col-lg-6">
                <label htmlFor="coach-restringing-enabled">
                  <input
                    id="coach-restringing-enabled"
                    type="checkbox"
                    checked={can_create_restring_orders}
                    onChange={(event) =>
                      setValues({
                        ...values,
                        error: false,
                        success: false,
                        can_create_restring_orders: event.target.checked,
                      })
                    }
                  />{" "}
                  Can create restringing orders
                </label>
              </div>
            ) : (
              ""
            )}
            {action === "Add" ? (
              <div className="form-content col-lg-6">
                <label htmlFor="">Create Password*</label>
                <br />
                <input
                  type="password"
                  value={password}
                  onChange={handleChange("password")}
                  placeholder="your password"
                  required
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-content col-lg-12">
              <button onClick={onSubmit}>{action} Coach</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopupForm;
